import { ExposedFormStatus, FormStatus } from 'state/forms/models';

export function translateAddonManagementFormStatus(status: string): ExposedFormStatus {
  switch (status) {
    case 'PATCHING':
      return 'Patching';
    case 'READY':
      return 'Ready';
    case 'REJECTED':
      return 'Rejected';
    case 'EXECUTED':
      return 'Executed';
    case 'EXECUTED_WITH_WARNING':
      return 'Warning';
    case 'UNKNOWN_ERROR':
      return 'UnknownError';
    case 'QUOTE_REQUESTED':
    case 'QUOTING':
      return 'Quoting';
    case 'QUOTED':
      return 'Quoted';
    case 'QUOTED_AND_AUTHORIZED':
      return 'QuotedAndAuthorized';
    case 'EXECUTING':
      return 'Executing';
    case 'EXECUTION_REQUESTED':
      return 'ExecutionRequested';
    case 'QUOTE_TIMEOUT':
      return 'QuoteTimeout';
    case 'TRADE_AUTHORIZATION_TIMEOUT':
      return 'TradeAuthorizationTimeout';
    case 'TRADE_TIMEOUT':
      return 'TradeTimeout';
    default:
      return 'NotReady';
  }
}

export function isReadOnlyForm(status: FormStatus): boolean {
  switch (status) {
    case 'EXECUTING':
    case 'QUOTING':
      return true;
    default:
      return false;
  }
}

export function canPriceInAddonManagementWorkspace(status: FormStatus): boolean {
  switch (status) {
    case 'READY':
    case 'REJECTED':
    case 'QUOTED':
    case 'EXECUTED':
    case 'QUOTE_TIMEOUT':
    case 'TRADE_TIMEOUT':
    case 'UNKNOWN_ERROR':
      return true;
    default:
      return false;
  }
}

export function canExecuteInAddonManagementWorkspace(status: FormStatus): boolean {
  switch (status) {
    case 'QUOTED':
      return true;
    default:
      return false;
  }
}

export function isAddonManagementFormTimeoutStatus(status?: ExposedFormStatus): boolean {
  switch (status) {
    case 'QuoteTimeout':
    case 'TradeAuthorizationTimeout':
    case 'TradeTimeout':
      return true;
    default:
      return false;
  }
}
export function getAddOnManagementColumnWidth(type: string): number {
  switch (type) {
    case 'checkbox':
      return 50;
    case 'status':
      return 75;
    case 'spotAndGreeks':
      return 260;
    default:
      return 150;
  }
}
